/* Action Types */
export const CANCEL = 'CANCEL';
export const LOAD_DOCUMENT = 'LOAD_DOCUMENT';
export const LOAD_WORKFLOW_INSTANCE = 'LOAD_WORKFLOW_INSTANCE';
export const INITIALIZE = 'INITIALIZE';
export const RESIZE = 'RESIZE';
export const SAVE = 'SAVE';
export const SHOW_ERROR = 'SHOW_ERROR';

/* Action Creators */
export function cancel() {
  return { type: CANCEL };
}

export function loadDocument(documentId) {
  return { type: LOAD_DOCUMENT, documentId };
}

export function loadWorkflowInstance(workflowInstanceId) {
  return { type: LOAD_WORKFLOW_INSTANCE, workflowInstanceId };
}

export function initialize(settings) {
  return { type: INITIALIZE, settings };
}

export function resize() {
  return { type: RESIZE };
}

export function save() {
  return { type: SAVE };
}

export function showError(error) {
  return { type: SHOW_ERROR, error };
}

const INITIAL_STATE = {
  documentIds: [],
  documentTypeIds: [],
  workflowInstanceId: null,
  hasSignature: null,
}

/* Reducer */
export default function reducer(state = INITIAL_STATE, action) {

  const { documentId, settings, type, workflowInstanceId, hasSignature } = action;

  switch(type) {
    case LOAD_DOCUMENT:
      return {
        ...state,
        documentIds: [documentId],
        hasSignature,
      };
    case LOAD_WORKFLOW_INSTANCE:
      return {
        ...state,
        workflowInstanceId: workflowInstanceId,
        hasSignature: null
      };
    case INITIALIZE:
      return {
        ...state,
        ...settings,
      };
    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/ducks/ApplicationDucks.js